var _defaultSpecifiers, _localGet, _utcGet, _timeIntervals, _utcIntervals;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { array, error, hasOwnProperty, extend, peek, toSet, constant, zero, one, span } from 'vega-util';
import { timeDay, timeWeek, utcDay, utcWeek, timeYear, timeMonth, timeHour, timeMinute, timeSecond, timeMillisecond, utcYear, utcMonth, utcHour, utcMinute, utcSecond, utcMillisecond } from 'd3-time';
import { bisector, tickStep } from 'd3-array';
var YEAR = 'year';
var QUARTER = 'quarter';
var MONTH = 'month';
var WEEK = 'week';
var DATE = 'date';
var DAY = 'day';
var DAYOFYEAR = 'dayofyear';
var HOURS = 'hours';
var MINUTES = 'minutes';
var SECONDS = 'seconds';
var MILLISECONDS = 'milliseconds';
var TIME_UNITS = [YEAR, QUARTER, MONTH, WEEK, DATE, DAY, DAYOFYEAR, HOURS, MINUTES, SECONDS, MILLISECONDS];
var UNITS = TIME_UNITS.reduce(function (o, u, i) {
  return o[u] = 1 + i, o;
}, {});
function timeUnits(units) {
  var u = array(units).slice(),
    m = {};

  // check validity
  if (!u.length) error('Missing time unit.');
  u.forEach(function (unit) {
    if (hasOwnProperty(UNITS, unit)) {
      m[unit] = 1;
    } else {
      error("Invalid time unit: ".concat(unit, "."));
    }
  });
  var numTypes = (m[WEEK] || m[DAY] ? 1 : 0) + (m[QUARTER] || m[MONTH] || m[DATE] ? 1 : 0) + (m[DAYOFYEAR] ? 1 : 0);
  if (numTypes > 1) {
    error("Incompatible time units: ".concat(units));
  }

  // ensure proper sort order
  u.sort(function (a, b) {
    return UNITS[a] - UNITS[b];
  });
  return u;
}
var defaultSpecifiers = (_defaultSpecifiers = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defaultSpecifiers, YEAR, '%Y '), QUARTER, 'Q%q '), MONTH, '%b '), DATE, '%d '), WEEK, 'W%U '), DAY, '%a '), DAYOFYEAR, '%j '), HOURS, '%H:00'), MINUTES, '00:%M'), SECONDS, ':%S'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defaultSpecifiers, MILLISECONDS, '.%L'), "".concat(YEAR, "-").concat(MONTH), '%Y-%m '), "".concat(YEAR, "-").concat(MONTH, "-").concat(DATE), '%Y-%m-%d '), "".concat(HOURS, "-").concat(MINUTES), '%H:%M'));
function timeUnitSpecifier(units, specifiers) {
  var s = extend({}, defaultSpecifiers, specifiers),
    u = timeUnits(units),
    n = u.length;
  var fmt = '',
    start = 0,
    end,
    key;
  for (start = 0; start < n;) {
    for (end = u.length; end > start; --end) {
      key = u.slice(start, end).join('-');
      if (s[key] != null) {
        fmt += s[key];
        start = end;
        break;
      }
    }
  }
  return fmt.trim();
}
var t0 = new Date();
function localYear(y) {
  t0.setFullYear(y);
  t0.setMonth(0);
  t0.setDate(1);
  t0.setHours(0, 0, 0, 0);
  return t0;
}
function dayofyear(d) {
  return localDayOfYear(new Date(d));
}
function week(d) {
  return localWeekNum(new Date(d));
}
function localDayOfYear(d) {
  return timeDay.count(localYear(d.getFullYear()) - 1, d);
}
function localWeekNum(d) {
  return timeWeek.count(localYear(d.getFullYear()) - 1, d);
}
function localFirst(y) {
  return localYear(y).getDay();
}
function localDate(y, m, d, H, M, S, L) {
  if (0 <= y && y < 100) {
    var date = new Date(-1, m, d, H, M, S, L);
    date.setFullYear(y);
    return date;
  }
  return new Date(y, m, d, H, M, S, L);
}
function utcdayofyear(d) {
  return utcDayOfYear(new Date(d));
}
function utcweek(d) {
  return utcWeekNum(new Date(d));
}
function utcDayOfYear(d) {
  var y = Date.UTC(d.getUTCFullYear(), 0, 1);
  return utcDay.count(y - 1, d);
}
function utcWeekNum(d) {
  var y = Date.UTC(d.getUTCFullYear(), 0, 1);
  return utcWeek.count(y - 1, d);
}
function utcFirst(y) {
  t0.setTime(Date.UTC(y, 0, 1));
  return t0.getUTCDay();
}
function utcDate(y, m, d, H, M, S, L) {
  if (0 <= y && y < 100) {
    var date = new Date(Date.UTC(-1, m, d, H, M, S, L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(y, m, d, H, M, S, L));
}
function floor(units, step, get, inv, newDate) {
  var s = step || 1,
    b = peek(units),
    _ = function _(unit, p, key) {
      key = key || unit;
      return getUnit(get[key], inv[key], unit === b && s, p);
    };
  var t = new Date(),
    u = toSet(units),
    y = u[YEAR] ? _(YEAR) : constant(2012),
    m = u[MONTH] ? _(MONTH) : u[QUARTER] ? _(QUARTER) : zero,
    d = u[WEEK] && u[DAY] ? _(DAY, 1, WEEK + DAY) : u[WEEK] ? _(WEEK, 1) : u[DAY] ? _(DAY, 1) : u[DATE] ? _(DATE, 1) : u[DAYOFYEAR] ? _(DAYOFYEAR, 1) : one,
    H = u[HOURS] ? _(HOURS) : zero,
    M = u[MINUTES] ? _(MINUTES) : zero,
    S = u[SECONDS] ? _(SECONDS) : zero,
    L = u[MILLISECONDS] ? _(MILLISECONDS) : zero;
  return function (v) {
    t.setTime(+v);
    var year = y(t);
    return newDate(year, m(t), d(t, year), H(t), M(t), S(t), L(t));
  };
}
function getUnit(f, inv, step, phase) {
  var u = step <= 1 ? f : phase ? function (d, y) {
    return phase + step * Math.floor((f(d, y) - phase) / step);
  } : function (d, y) {
    return step * Math.floor(f(d, y) / step);
  };
  return inv ? function (d, y) {
    return inv(u(d, y), y);
  } : u;
}

// returns the day of the year based on week number, day of week,
// and the day of the week for the first day of the year
function weekday(week, day, firstDay) {
  return day + week * 7 - (firstDay + 6) % 7;
}

// -- LOCAL TIME --

var localGet = (_localGet = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_localGet, YEAR, function (d) {
  return d.getFullYear();
}), QUARTER, function (d) {
  return Math.floor(d.getMonth() / 3);
}), MONTH, function (d) {
  return d.getMonth();
}), DATE, function (d) {
  return d.getDate();
}), HOURS, function (d) {
  return d.getHours();
}), MINUTES, function (d) {
  return d.getMinutes();
}), SECONDS, function (d) {
  return d.getSeconds();
}), MILLISECONDS, function (d) {
  return d.getMilliseconds();
}), DAYOFYEAR, function (d) {
  return localDayOfYear(d);
}), WEEK, function (d) {
  return localWeekNum(d);
}), _defineProperty(_defineProperty(_localGet, WEEK + DAY, function (d, y) {
  return weekday(localWeekNum(d), d.getDay(), localFirst(y));
}), DAY, function (d, y) {
  return weekday(1, d.getDay(), localFirst(y));
}));
var localInv = _defineProperty(_defineProperty({}, QUARTER, function (q) {
  return 3 * q;
}), WEEK, function (w, y) {
  return weekday(w, 0, localFirst(y));
});
function timeFloor(units, step) {
  return floor(units, step || 1, localGet, localInv, localDate);
}

// -- UTC TIME --

var utcGet = (_utcGet = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_utcGet, YEAR, function (d) {
  return d.getUTCFullYear();
}), QUARTER, function (d) {
  return Math.floor(d.getUTCMonth() / 3);
}), MONTH, function (d) {
  return d.getUTCMonth();
}), DATE, function (d) {
  return d.getUTCDate();
}), HOURS, function (d) {
  return d.getUTCHours();
}), MINUTES, function (d) {
  return d.getUTCMinutes();
}), SECONDS, function (d) {
  return d.getUTCSeconds();
}), MILLISECONDS, function (d) {
  return d.getUTCMilliseconds();
}), DAYOFYEAR, function (d) {
  return utcDayOfYear(d);
}), WEEK, function (d) {
  return utcWeekNum(d);
}), _defineProperty(_defineProperty(_utcGet, DAY, function (d, y) {
  return weekday(1, d.getUTCDay(), utcFirst(y));
}), WEEK + DAY, function (d, y) {
  return weekday(utcWeekNum(d), d.getUTCDay(), utcFirst(y));
}));
var utcInv = _defineProperty(_defineProperty({}, QUARTER, function (q) {
  return 3 * q;
}), WEEK, function (w, y) {
  return weekday(w, 0, utcFirst(y));
});
function utcFloor(units, step) {
  return floor(units, step || 1, utcGet, utcInv, utcDate);
}
var timeIntervals = (_timeIntervals = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_timeIntervals, YEAR, timeYear), QUARTER, timeMonth.every(3)), MONTH, timeMonth), WEEK, timeWeek), DATE, timeDay), DAY, timeDay), DAYOFYEAR, timeDay), HOURS, timeHour), MINUTES, timeMinute), SECONDS, timeSecond), _defineProperty(_timeIntervals, MILLISECONDS, timeMillisecond));
var utcIntervals = (_utcIntervals = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_utcIntervals, YEAR, utcYear), QUARTER, utcMonth.every(3)), MONTH, utcMonth), WEEK, utcWeek), DATE, utcDay), DAY, utcDay), DAYOFYEAR, utcDay), HOURS, utcHour), MINUTES, utcMinute), SECONDS, utcSecond), _defineProperty(_utcIntervals, MILLISECONDS, utcMillisecond));
function timeInterval(unit) {
  return timeIntervals[unit];
}
function utcInterval(unit) {
  return utcIntervals[unit];
}
function offset(ival, date, step) {
  return ival ? ival.offset(date, step) : undefined;
}
function timeOffset(unit, date, step) {
  return offset(timeInterval(unit), date, step);
}
function utcOffset(unit, date, step) {
  return offset(utcInterval(unit), date, step);
}
function sequence(ival, start, stop, step) {
  return ival ? ival.range(start, stop, step) : undefined;
}
function timeSequence(unit, start, stop, step) {
  return sequence(timeInterval(unit), start, stop, step);
}
function utcSequence(unit, start, stop, step) {
  return sequence(utcInterval(unit), start, stop, step);
}
var durationSecond = 1000,
  durationMinute = durationSecond * 60,
  durationHour = durationMinute * 60,
  durationDay = durationHour * 24,
  durationWeek = durationDay * 7,
  durationMonth = durationDay * 30,
  durationYear = durationDay * 365;
var Milli = [YEAR, MONTH, DATE, HOURS, MINUTES, SECONDS, MILLISECONDS],
  Seconds = Milli.slice(0, -1),
  Minutes = Seconds.slice(0, -1),
  Hours = Minutes.slice(0, -1),
  Day = Hours.slice(0, -1),
  Week = [YEAR, WEEK],
  Month = [YEAR, MONTH],
  Year = [YEAR];
var intervals = [[Seconds, 1, durationSecond], [Seconds, 5, 5 * durationSecond], [Seconds, 15, 15 * durationSecond], [Seconds, 30, 30 * durationSecond], [Minutes, 1, durationMinute], [Minutes, 5, 5 * durationMinute], [Minutes, 15, 15 * durationMinute], [Minutes, 30, 30 * durationMinute], [Hours, 1, durationHour], [Hours, 3, 3 * durationHour], [Hours, 6, 6 * durationHour], [Hours, 12, 12 * durationHour], [Day, 1, durationDay], [Week, 1, durationWeek], [Month, 1, durationMonth], [Month, 3, 3 * durationMonth], [Year, 1, durationYear]];
function bin(opt) {
  var ext = opt.extent,
    max = opt.maxbins || 40,
    target = Math.abs(span(ext)) / max;
  var i = bisector(function (i) {
      return i[2];
    }).right(intervals, target),
    units,
    step;
  if (i === intervals.length) {
    units = Year, step = tickStep(ext[0] / durationYear, ext[1] / durationYear, max);
  } else if (i) {
    i = intervals[target / intervals[i - 1][2] < intervals[i][2] / target ? i - 1 : i];
    units = i[0];
    step = i[1];
  } else {
    units = Milli;
    step = Math.max(tickStep(ext[0], ext[1], max), 1);
  }
  return {
    units: units,
    step: step
  };
}
export { DATE, DAY, DAYOFYEAR, HOURS, MILLISECONDS, MINUTES, MONTH, QUARTER, SECONDS, TIME_UNITS, WEEK, YEAR, dayofyear, bin as timeBin, timeFloor, timeInterval, timeOffset, timeSequence, timeUnitSpecifier, timeUnits, utcFloor, utcInterval, utcOffset, utcSequence, utcdayofyear, utcweek, week };